import { FieldHookConfig } from 'formik'
import { CustomFieldProps } from 'src/ui-components/forms/formik/InputField'

export type Field = CustomFieldProps & FieldHookConfig<string>

const isRequired = (value: string): string => {
  if (value === undefined || value === '') return 'required'
  return undefined
}

const isOutOfInterval = (value: number, min: number, max: number) => {
  if (value < min || value > max) {
    return `Min ${min} and max ${max}`
  }
  return undefined
}

const validatePartNumber = (value: string): string => {
  return isRequired(value) ?? isOutOfInterval(value?.length, 0, 20) ?? undefined
}

const validateStockQty = (value: number): string => {
  return (
    isRequired(value?.toString()) ?? isOutOfInterval(value, 0, 999) ?? undefined
  )
}

const baseFieldStyle = { minHeight: '40px', padding: '0px 8px' }

export const mapToField = (name: string): Field => {
  switch (name) {
    case 'lineCode':
      return {
        name,
        type: 'text',
        style: { ...baseFieldStyle, textTransform: 'uppercase', width: '69px' },
        maxSize: 3,
      }
    case 'partNumber':
      return {
        name,
        type: 'text',
        style: {
          ...baseFieldStyle,
          textTransform: 'uppercase',
          width: '182px',
        },
        validate: (v) => validatePartNumber(v),
      }
    case 'stockQty':
      return {
        name,
        type: 'number',
        style: { ...baseFieldStyle, width: '75px' },
        validate: (v) => validateStockQty(v),
        maxSize: 3,
        min: 0,
      }
    case 'comment':
      return {
        name,
        type: 'textarea',
        maxSize: 45,
        style: { ...baseFieldStyle, width: '312px' },
      }
    default:
      return undefined
  }
}
